import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { ViewboxGuestEffects } from './viewbox-guest.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ViewboxGuestEffects])],
})
export class ViewboxGuestDataModule {}
